import { useEffect } from 'react';
import { PAGES } from 'routes';
import { get, isEmpty, isNil } from 'lodash';
import { isManager } from 'containers/AppContainer/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { appConfigListingTyping } from 'typings/globalTypes';

const useVersionCheck = (props: any) => {
  useEffect(() => {
    const checkVersion = () => {
      const frontVersion = process.env.REACT_APP_VERSION;

      const backVersion = get(
        get(props.listings, 'appConfig', []).find(
          (item: appConfigListingTyping) => item.task === 'APP_VERSION_WEB',
        ),
        'value',
        null,
      );
      if (
        isManager(props) &&
        currentUserStorage?.get()?.username &&
        props.listings &&
        !isEmpty(get(props.listings, 'appConfig', []))
      ) {
        if (frontVersion !== backVersion || isNil(backVersion)) {
          alert(
            `Merci d'utiliser un navigateur Privé ou de rafraichir le navigateur avant de procéder aux traitements - version actuelle ( ${frontVersion} )`,
          );
          localStorage.clear(); // or your logout function
          window.location.href = PAGES.LOGIN_MANAGER; // or refresh
        }
      }
    };

    checkVersion();
  }, [props.listings]);
};
export default useVersionCheck;
